export default {
  featuredExperiences: 'Nasze wyróżnione doświadczenia',
  searchAllExperiences: 'Szukaj wszystkich doświadczeń',
  searchAll: 'Szukaj wszystko',
  groupSize: 'Wielkość grupy',
  eventSize: 'Wielkość wydarzenia',
  upTo: 'Do',
  whatWeDo: 'Co będziemy robić',
  hostedBy: 'Prowadzone przez',
  whatsIncluded: 'Co jest w cenie',
  avail: 'Dostępność',
  whereWeAre: 'Gdzie będziemy',
  experienceCalendar: 'Kalendarz doświadczeń',
  experienceCancelled: 'Doświadczenie anulowane',
  experienceStartingPrice: 'Od {{price}}',
  experienceTotalPrice: 'Suma {{price}}',
  at: 'o',
  viewPrivateSessAvailability: 'Zobacz dostępność sesji prywatnych',
  selectDuration: 'Czas trwania',
  selectStartTime: 'Godzina rozpoczęcia',
  selectSession: 'Wybierz sesję',
  sessionsCount: '{{count}} godzin — wybierz godzinę',
  noAvailability: 'Brak dostępności',
  select: 'Wybierz',
  slotLeft: 'Pozostało {{remainSlots}} miejsce',
  slotsLeft: 'Pozostało {{remainSlots}} miejsc',
  spotsLeft: '{{count}} pozostało',
  spotsLeftAriaLabel: '{{count}} miejsc pozostało',
  bookExperience: 'Zarezerwuj doświadczenie',
  book: 'Zarezerwuj',
  learnMore: 'Dowiedz się więcej',
  apply: 'Zastosuj',
  maxPartySizes: 'Maksymalnie {{maxGroupSize}} miejsc na grupę',
  maxPartySize: 'Maksymalnie {{maxGroupSize}} miejsce na grupę',
  selectSessionValidation: 'Proszę wybrać sesję',
  selectParticipantValidation: 'Proszę wybrać uczestników',
  selectDateValidation: 'Proszę wybrać datę',
  reminders: 'Przypomnienia',
  seeOtherDates: 'Zobacz inne daty',
  location: 'Lokalizacja',
  about: 'O doświadczeniu',
  allExperiences: 'Wszystkie doświadczenia',
  soldOut: 'Wyprzedane',
  addOns: 'Dodatki',
  reviews: 'Recenzje',
  reviewSingular: 'recenzja',
  reviewPlural: 'recenzji',
  dateOfExperience: 'Data doświadczenia',
  readLess: 'Czytaj mniej',
  readMore: 'Czytaj więcej',
  seeMore: 'Zobacz więcej',
  details: 'Szczegóły',
  durationHour: 'godzina',
  durationHours: 'godziny',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'Poniższy film nie zawiera dźwięku',
  by: 'Autor',
  chooseATime: 'Wybierz godzinę dla {{title}}',
  amenities: 'Udogodnienia',
  ticketSalesOpenIn: 'Sprzedaż biletów rozpocznie się za',
  ticketSalesOpen: 'Sprzedaż biletów otwarta',
  ticketSalesCloseIn: 'Sprzedaż biletów zakończy się za',
  ticketSalesClose: 'Sprzedaż biletów się kończy',
  ticketSalesClosed: 'Sprzedaż biletów zakończona',
  comingSoon: 'Wkrótce',
  inPartnershipWith: 'We współpracy z',
  notFoundExperienceTitle: 'To doświadczenie nie jest już dostępne',
  notFoundExperienceSubtitle:
    'Mogło zostać wycofane lub link może być już nieaktualny.',
  deadLinkRecoverySubtitle: 'Odkryj inne doświadczenia dostępne do rezerwacji',
  viewAllExperiences: 'Zobacz wszystkie doświadczenia',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Zdobądź 5 punktów bazowych</strong> za każdy kwalifikujący się 1 USD wydany po zalogowaniu się na konto World of Hyatt w celu rezerwacji tego doświadczenia</p>',
      basePoints:
        '<p><strong>Zdobądź 10 punktów bazowych</strong> za każdy kwalifikujący się 1 USD wydany po zalogowaniu się na konto World of Hyatt w celu rezerwacji tego doświadczenia</p>',
      additionalBonusPoints:
        '<p><strong>Zdobądź dodatkowe 4 punkty bonusowe</strong> za każdy kwalifikujący się 1 USD wydany przy rezerwacji kartą World of Hyatt Credit Card</p>',
      additionalBonusPointsTier:
        '<p><strong>Zdobądź do 30% dodatkowych punktów bonusowych</strong> w zależności od poziomu członkostwa</p>',
      payWithPoints:
        '<p><strong>Zapłać punktami</strong> rezerwując to doświadczenie</p>',
    },
  },
};
